import TelegramService from './TelegramService';
import ClaudeService from './ClaudeService';
import { db } from '../../firebase';
import { setDoc, doc, getDoc } from 'firebase/firestore';

class SystemManager {
  constructor() {
    this.telegram = TelegramService;
    this.ai = ClaudeService;
  }

  // Initialiser system for en bruger
  async initializeSystem(userId) {
    try {
      const userRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userRef);

      if (!userDoc.exists()) {
        await setDoc(userRef, {
          userId,
          telegramConnected: false,
          linkedInConnected: false,
          createdAt: new Date()
        });
      }
    } catch (error) {
      console.error('Fejl ved initialisering af system:', error);
      throw error;
    }
  }

  // Håndter indkommende Telegram beskeder
  async handleTelegramMessage(chatId, message) {
    try {
      // Generer svar med Claude
      const aiResponse = await this.ai.generateResponse(message);
      
      // Send svar tilbage via Telegram
      await this.telegram.sendMessage(chatId, aiResponse);
      
      return true;
    } catch (error) {
      console.error('Fejl ved håndtering af Telegram besked:', error);
      throw error;
    }
  }
}

const systemManager = new SystemManager();
export default systemManager; 